import { GoogleMapsCore } from '../../../../components/googleMaps/GoogleMapsCore/GoogleMapsGeneral';

export const GoogleMapsView = () => {
  return (
    <GoogleMapsCore type="view" />
  )
}